/**
 * ─── Entity About Route Pages ──────────────────────────────
 * Thin route-level components that render EntityAboutPage
 * with the correct entityPath for each business system.
 *
 * To add a new About page:
 * 1. Add data to entity-about-data.ts
 * 2. Add export here
 * 3. Add route in router.tsx
 * 4. Add nav item in useDynamicNav.ts STATIC_GROUP_ITEMS
 */

import { EntityAboutPage } from '../components/EntityAboutPage'

// Cooperative Core
export function CooperativeAboutPage() {
  return <EntityAboutPage entityPath="/cooperative/about" />
}

// Laundry Shop
export function LaundryAboutPage() {
  return <EntityAboutPage entityPath="/laundry/about" />
}

// Driving School
export function DrivingSchoolAboutPage() {
  return <EntityAboutPage entityPath="/driving-school/about" />
}

// Crispy King Fast Food
export function FastFoodAboutPage() {
  return <EntityAboutPage entityPath="/fastfood/about" />
}

// Clinic Management System
export function ClinicAboutPage() {
  return <EntityAboutPage entityPath="/clinic/about" />
}

// HRIS
export function HrisAboutPage() {
  return <EntityAboutPage entityPath="/hris/about" />
}

// Water Station
export function WaterStationAboutPage() {
  return <EntityAboutPage entityPath="/water-station/about" />
}

// Collections
export function CollectionsAboutPage() {
  return <EntityAboutPage entityPath="/collections/about" />
}

export function ArenaAboutPage() {
  return <EntityAboutPage entityPath="/arena/about" />
}

export function PawnshopAboutPage() {
  return <EntityAboutPage entityPath="/pawnshop/about" />
}

export function JewelryAboutPage() {
  return <EntityAboutPage entityPath="/jewelry/about" />
}
